// extracted by mini-css-extract-plugin
module.exports = {"link":"vjMqk","root":"xxex3","label":"_2TTZA"};